import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Processo, ProcessoAdvogado } from '@app/models/processo.model';
import { ProcessoService } from '@app/services/processo.service';
import { ConsultasService } from '@app/services/consultas.service';

import { CDSMask } from '@app/utils/cds-mask';
import debounce from '@app/utils/debounce';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { PlanoControleService } from '@app/services/plano-controle.service';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-processo-administrativo-form',
  templateUrl: './processo-administrativo-form.component.html'
})
export class ProcessoAdministrativoFormComponent implements OnInit {

  cdsMask = new CDSMask();
  aguardandoSolicitacao: boolean = false;
  aguardandoArquivamento: boolean = false;
  titulo: string;
  processo: Processo;

  lstParticipante: Array<IdDescricao> = [];
  lstTipoDeAcao: Array<IdDescricao> = [];
  lstEstadoDoProcesso: Array<IdDescricao> = [];
  lstRito: Array<IdDescricao> = [];
  lstPosicaoDoCliente: Array<IdDescricao> = [];
  lstNaturezaDeAcao: Array<IdDescricao> = [];
  listaNaturezaDeAcaoFiltrada: Array<IdDescricao> = [];
  lstParceiros: Array<IdDescricao> = [];
  lstAdvogadosParceiros: Array<IdDescricao> = [];
  lstAdvogados: Array<IdDescricao> = [];
  lstUnidades: Array<IdDescricao> = [];

  lstErros: string[];
  veioDoCadastro = false;
  precisaInformarDataEfetivaEstadoPorQueMudouEstadoProcesso = false;
  estadoDoProcessoOriginalId: number = 0;
  tipos: string[] = ['ADMINISTRATIVO', 'JUDICIAL'];

  novo = true;
  bloquearSelecaoTipo = false;

  _debounce: any;
  _pesquisa: any;

  usuarioPodeAlterarUnidade: boolean;
  usuarioPodeArquivar: boolean;

  percentualUtilizadoPlano: number = 0;

  processoArquivado: boolean = false;
  bsModalRef: BsModalRef;
  dataEfetivaEstadoProcessoOriginal: string | undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
    private usuarioTipoService: UsuarioTipoService,
    private planoControleService: PlanoControleService,
    @Inject(ToastrService) private toastr: ToastrService,
    private bsModalService: BsModalService
  ) {

    this.processo = new Processo();
    this.processo.Id = null;
    this.processo.Tipo = 'ADMINISTRATIVO';
    this.processo.TipoDeAcaoId = 0;
    this.processo.PosicaoDoClienteId = 0;
    this.processo.NaturezaDeAcaoId = 0;
    this.processo.EstadoDoProcessoId = 0;
    this.processo.RitoId = 0;

    this.processo.EncaminhadoPor = null;
    this.processo.SubstabelecidoPor = null;
    this.router.events.subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit() {
    this.planoControleService.obterControle().subscribe(data => this._calculaPlanoUso(data));

    this.route.params.subscribe((params: any) => {
      const id = params['id'];
      const participanteId = params['participanteId'];
      const participanteNome = params['participanteNome'];
      this.titulo = id ? 'Editar Processo Administrativo' : 'Novo Processo Administrativo';

      this._preencheDropdowns();
      // novo
      if (!id) {
        this._cadastroFluxoInicial(participanteId, participanteNome);
        return;
      }
      // editar
      this._edicaoFluxoInicial(id);
    });

    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(permissoes => {
      this.usuarioPodeAlterarUnidade = permissoes.find(x => x.Descricao == 'EditarUnidadeProcesso').Selecionado;
      this.usuarioPodeArquivar = permissoes.find(x => x.Descricao == 'ArquivarProcesso').Selecionado
    }
    );
  }

  private _calculaPlanoUso(dados) {
    if (dados.LimiteProcessos === 0)
      return;
    this.percentualUtilizadoPlano = dados.ProcessosUtilizados / dados.LimiteProcessos * 100;
  }

  private _edicaoFluxoInicial(id: any) {
    this.processoService.obterPorId(id).subscribe(data => {
      this.processo = data;
      this.estadoDoProcessoOriginalId = this.processo.EstadoDoProcessoId;
      this.dataEfetivaEstadoProcessoOriginal = this.processo.DataEfetivaEstadoProcesso;
      this.processoArquivado = this.processo.Arquivado;
      //this.estadoDoProcessoOriginalId = this.processo.EstadoDoProcessoId;
      this.precisaInformarDataEfetivaEstadoPorQueMudouEstadoProcesso = false;
      // Se a data existir, corta o "T00:00:00" fora:
      if (this.processo.DataEfetivaEstadoProcesso) {
        this.processo.DataEfetivaEstadoProcesso = this.processo.DataEfetivaEstadoProcesso.split('T')[0];
      }
      if (this.processo.ClienteNome) {
        this.processo.Tipo = 'ADMINISTRATIVO';

        this.lstParticipante.length = 0;
        let preencheParticipanteEditar: IdDescricao = new IdDescricao();
        preencheParticipanteEditar.Id = this.processo.ClienteId;
        preencheParticipanteEditar.Descricao = this.processo.ClienteNome;
        this.lstParticipante.push(preencheParticipanteEditar);
      }
    });
    this.novo = false;
    this.bloquearSelecaoTipo = true;
  }

  private _cadastroFluxoInicial(participanteId: any, participanteNome: any) {
    this.processo.Id = 0;
    if (participanteId !== undefined) {
      this.processo.ClienteId = participanteId;
      this.processo.ClienteNome = participanteNome;
      this.veioDoCadastro = true;
    } else {
      this.adicionarAdvogado();
    }
  }

  adicionarAdvogado() {
    const processoAdvogado = new ProcessoAdvogado();
    processoAdvogado.AdvogadoId = 0;
    processoAdvogado.ProcessoId = this.processo.Id;
    this.processo.ProcessoAdvogado.push(processoAdvogado);
  }

  removerAdvogado(index: number) {
    this.processo.ProcessoAdvogado.splice(index, 1);
  }

  dropchange() {
    const _processo = { ...this.processo };
    var teste = _processo.Id;
    if (this.processo.Tipo == 'JUDICIAL') {
      this.router.navigate(['./processos/processo-judicial-editar/' + teste]);
    }
  }

  onSubmit() {
    this.aguardandoSolicitacao = true
    this.gravarProcesso();
  }

  arquivarProcesso() {
    this.bsModalRef = this.bsModalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente arquivar este processo?';
    this.bsModalRef.content.confirmar = () => {
      this.aguardandoArquivamento = true;
      this.processo.Arquivado = true;
      this.gravarProcesso();
    };
  }

  private gravarProcesso() {
    const _processo = { ...this.processo };
    _processo.Cliente = null;
    const data = _processo.DataEfetivaEstadoProcesso;


    if (this.precisaInformarDataEfetivaEstadoPorQueMudouEstadoProcesso === true) {
      if (!_processo.DataEfetivaEstadoProcesso /* ou ele é diferente do que veio do banco*/) {
        this.toastr.error("A data efetiva do estado não foi preenchida!");
        console.log("A data não foi preenchida ou é a default!", _processo.DataEfetivaEstadoProcesso);
        this.aguardandoSolicitacao = false;
        return;

      }
    }
      // and verificar se a data efetiva do estado é diferente da que veio do banco, e se for, mostrar o erro
    else if(!_processo.DataEfetivaEstadoProcesso && this.estadoDoProcessoOriginalId !== _processo.EstadoDoProcessoId) {
      this.toastr.error("A data efetiva do estado não foi preenchida!");
      console.log("A data não foi preenchida ou é a default!", _processo.DataEfetivaEstadoProcesso);
      this.aguardandoSolicitacao = false;
      return;
    }else if (_processo.DataEfetivaEstadoProcesso?.IsNullOrEmpty()) {
      if(!this.dataEfetivaEstadoProcessoOriginal?.IsNullOrEmpty()){
        this.aguardandoSolicitacao = false;
        this.toastr.error("A data efetiva do estado não foi preenchida!");
        console.log("A data não foi preenchida ou é a default!", _processo.DataEfetivaEstadoProcesso);
        return;
    }
    this.aguardandoSolicitacao = false;

  }

   
    // // and verificar se a data efetiva do estado é diferente da que veio do banco, e se for, mostrar o erro
    // else if((data === null || data === undefined || data === '' ) && this.estadoDoProcessoOriginalId !== _processo.EstadoDoProcessoId) {
    //   this.toastr.error("A data efetiva do estado não foi preenchida!");
    //   console.log("A data não foi preenchida ou é a default!", _processo.DataEfetivaEstadoProcesso);
    //   this.aguardandoSolicitacao = false;
    //   return;
    // }

    

    console.log("ALOOO", _processo.DataEfetivaEstadoProcesso, typeof _processo.DataEfetivaEstadoProcesso);

    this.processoService.gravar(_processo).toPromise().then(
      (data) => { this.router.navigate(['./processos/processo', data]); },
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
        this.aguardandoArquivamento = false;
      });

  }

  desarquivarProcesso() {
    this.bsModalRef = this.bsModalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente desarquivar este processo?';
    this.bsModalRef.content.confirmar = () => {
      this.aguardandoArquivamento = true;
      this.processoService.desarquivarProcesso(this.processo.Id).subscribe(
        () => this.router.navigate(['./processos/processo', this.processo.Id]),
        (erro) => {
          this.toastr.error(erro.error.errors[0])
          this.aguardandoArquivamento = false;
        }
      );
    };

  }

  completaCliente() {
    this._sanitizar();
    this.processo.ValorPorcentualCliente = Number((100 - this.processo.ValorPorcentualEscritorio).toFixed(2));
  }

  completaEscritorio() {
    this._sanitizar();
    this.processo.ValorPorcentualEscritorio = Number((100 - this.processo.ValorPorcentualCliente).toFixed(2));
  }

  private _sanitizar(): void {
    if (this.processo.ValorPorcentualCliente.toString().indexOf(','))
      this.processo.ValorPorcentualCliente = Number(this.processo.ValorPorcentualCliente.toString().replace(',', '.'));
    if (this.processo.ValorPorcentualEscritorio.toString().indexOf(','))
      this.processo.ValorPorcentualEscritorio = Number(this.processo.ValorPorcentualEscritorio.toString().replace(',', '.'));
  }

  selecionaTipoAcaoRelacionado(): void {
    this.processo.TipoDeAcaoId = this.lstNaturezaDeAcao
      .filter((n) => n.Id == this.processo.NaturezaDeAcaoId)[0].Extra1;

    this.bloquearSelecaoTipo = true;
  }

  removeBloqueioSelecaoTipo() {
    this.bloquearSelecaoTipo = false;
  }

  onEstadoDoProcessoChanged(): void {
    this.precisaInformarDataEfetivaEstadoPorQueMudouEstadoProcesso = this.processo.EstadoDoProcessoId !== this.estadoDoProcessoOriginalId;
    this.processo.DataEfetivaEstadoProcesso = undefined;
  }

  filtraNaturezaBaseadoTipoAcao(): void {
    let aplicacaoFiltro = this.lstNaturezaDeAcao
      .filter((naturezaDeAcao) => naturezaDeAcao.Extra1 == this.processo.TipoDeAcaoId);

    this.listaNaturezaDeAcaoFiltrada.length = 0;
    if (aplicacaoFiltro.length > 0) {

      this.listaNaturezaDeAcaoFiltrada.push(...aplicacaoFiltro);
      let possuiSelecaoNaListaFiltrada: boolean = this.listaNaturezaDeAcaoFiltrada
        .some(n => n.Id == this.processo.NaturezaDeAcaoId);

      if (!possuiSelecaoNaListaFiltrada) {
        this.processo.NaturezaDeAcaoId = 0;
      }
      return;
    }

    this.processo.NaturezaDeAcaoId = 0;
    this.listaNaturezaDeAcaoFiltrada.push(...this.lstNaturezaDeAcao);
  }

  private _preenchimentoPadrao(buscaTipo: string, dropdownList: Array<IdDescricao>) {
    this.consultasService.consultar(buscaTipo).toPromise()
      .then(data => {
        dropdownList.length = 0;
        dropdownList.push(...data);
      }
      );
  }

  private _preencheDropdowns(): void {
    this._preenchimentoPadrao('TIPODEACAO', this.lstTipoDeAcao);
    this.consultasService.consultar('NATUREZADEACAO').toPromise()
      .then(data => {
        this.lstNaturezaDeAcao.length = 0;
        this.listaNaturezaDeAcaoFiltrada.length = 0;
        //
        this.lstNaturezaDeAcao.push(...data);
        this.listaNaturezaDeAcaoFiltrada.push(...data);
      }
      );

    this._preenchimentoPadrao('ESTADODOPROCESSO', this.lstEstadoDoProcesso);
    this._preenchimentoPadrao('POSICAODOCLIENTE', this.lstPosicaoDoCliente);
    this._preenchimentoPadrao('RITO', this.lstRito);
    this._preenchimentoPadrao('PARCEIRO', this.lstParceiros);
    this._preenchimentoPadrao('ADVOGADOPARCEIRO', this.lstAdvogadosParceiros);
    this._preenchimentoPadrao('ADVOGADO', this.lstAdvogados);
    this._preenchimentoPadrao('UNIDADE_S_RATEIO', this.lstUnidades);
  }
}

